'use client';

import { useSystemLabels } from '@eliadmin/core/src/hooks/use-system-labels';
import Link from '@eliadmin/core/src/components/link';

import { CartBadge } from '@eliadmin/core/src/components/header/cart-badge';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { HEADER_CONFIG } from '@eliadmin/core/src/constants/header-config';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useCartQueryOpts } from '@eliadmin/core/src/hooks/cart/use-cart';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useQuery } from '@tanstack/react-query';

import { PiShoppingCart } from 'react-icons/pi';

export type HeaderCartButtonProps = {
  isHomepage?: boolean;
};

export function HeaderCartButton({ isHomepage }: HeaderCartButtonProps) {
  const systemLabels = useSystemLabels();
  const { data: cart } = useQuery({ ...useCartQueryOpts() });

  return (
    <Link aria-label={systemLabels('cart')} href={ROUTES.CART() ?? '#'} prefetch={true}>
      <Button
        asChild
        size={'icon'}
        variant={isHomepage ? 'alternative-alt' : 'alternative-default'}
        className={cn('w-fit text-center',
          'relative', 'ea-cart-button')}
      >
        <div data-ea-visual-tag="button">
          <div className="relative">
            {<PiShoppingCart size={20} />}

            <CartBadge
              className={cn(
                '-right-2 -top-2 h-4 w-4 bg-[#ED1A3B] text-[10px] font-normal text-white',
              )}
              variant={HEADER_CONFIG.headerMain.cart.badgeVariant}
            />
          </div>
        </div>
      </Button>
    </Link>
  );
}
